<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('user.pageTitle') }}
      </h1>
      <ts-breadcrumb :items="[
        { text: $t('toHomePage'), href: '/' },
        {
          text: $t('user.pageTitle'),
          href: '/users'
        },
        {
          text: $t('create'),
          active: true
        }
      ]" />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <form class="form-horizontal">
          <fieldset>
            <legend>{{ $t('user.userAccount') }}</legend>
            <div class="row">
              <div class="col-md-6">
                <div class="row">
                  <ts-loading-banner :loading="loading">
                    <div class="col-md-12">
                      <div class="row form-group">
                        <label class="col-md-4 col-form-label required">{{
                          $t('user.userName')
                        }}</label>
                        <div class="col-md-8">
                          <input type="text" class="form-control" :class="{ 'is-invalid': errors.has('loginname') }"
                            v-model.trim="model.loginname" />
                          <div class="invalid-feedback" v-if="errors.has('loginname')">
                            {{ errors.first('loginname') }}
                          </div>
                        </div>
                      </div>
                      <div class="row form-group">
                        <label class="col-md-4 col-form-label required">{{
                          $t('user.activateType')
                        }}</label>
                        <div class="col-md-8">
                          <a-select v-model.number="model.activated_type_id">
                            <a-select-option :value="1">
                              {{ $t('user.parent') }}</a-select-option>
                            <a-select-option :value="2">
                              {{ $t('user.student') }}</a-select-option>
                            <a-select-option :value="3">{{
                              $t('user.studentPickup')
                            }}</a-select-option>
                            <a-select-option :value="4">{{
                              $t('user.driver')
                            }}</a-select-option>
                            <a-select-option :value="5">{{
                              $t('user.teacher')
                            }}</a-select-option>
                            <a-select-option :value="6">{{
                              $t('user.officeStaff')
                            }}</a-select-option>
                          </a-select>
                          <div class="validate" v-if="errors.has('activated_type_id')">
                            {{ errors.first('activated_type_id') }}
                          </div>
                        </div>
                      </div>
                      <div class="row form-group">
                        <label class="col-md-4 col-form-label required">{{
                          $t('user.employee')
                        }}</label>
                        <div class="col-md-8">
                          <a-select v-model.number="model.staff_id" style="width: 100%" :options="employees"
                            :showSearch="true" option-filter-prop="children" :filter-option="
                              (input, option) =>
                                option.componentOptions.children[0].text
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                            "></a-select>
                          <div class="validate" v-if="errors.has('staff_id')">
                            {{ errors.first('staff_id') }}
                          </div>
                        </div>
                      </div>
                      <div class="row form-group">
                        <label class="col-md-4 col-form-label"></label>
                        <div class="col-md-8">
                          <ts-checkbox v-model="model.is_allow_back_day">{{
                            $t('user.allowBackDay')
                          }}</ts-checkbox>
                        </div>
                      </div>
                      <div class="row form-group">
                        <label class="col-md-4 col-form-label"></label>
                        <div class="col-md-8">
                          <ts-checkbox v-model="model.disable">{{
                            $t('user.disable')
                          }}</ts-checkbox>
                        </div>
                      </div>
                    </div>
                  </ts-loading-banner>
                </div>
                <!-- branch list -->
                <branch-list v-model="model" :validate="errors" />
                <!-- role component -->
                <role-list v-model="model" />
                <!-- sub program -->
                <sub-program v-model="model" />
              </div>
              <div class="col-md-6">
                <permission-component v-model="model" />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 text-right">
                <ts-button class="mr-2" @click.prevent="$router.push({ name: 'user' })">{{ $t('cancel') }}</ts-button>
                <ts-button color="primary" :waiting="waiting" @click.prevent="onUpdate">{{ $t('update') }}</ts-button>
              </div>
            </div>
          </fieldset>
        </form>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { transform } from 'lodash'
import { Errors } from 'form-backend-validation'
import { mapActions, mapState } from 'vuex'
import RoleList from './components/role-component'
import BranchList from './components/branch-list'
import SubProgram from './components/sub-program-list'
import PermissionComponent from './components/permission-component'

export default {
  name: 'UserCreateEdit',
  components: {
    RoleList,
    BranchList,
    SubProgram,
    PermissionComponent
  },
  data() {
    return {
      loading: false,
      waiting: false,
      errors: new Errors(),
      model: {
        user_id: 0,
        loginname: null,
        password: null,
        password_confirmation: null,
        staff_id: null,
        cashier_location_id: null,
        activated_type_id: 6,
        disable: false,
        roles: [],
        branches: [],
        sub_programs: [],
        permissions: [],
        is_allow_back_day: false
      }
    }
  },
  created() {
    this.fetchData()
    this.setEditData()
  },
  computed: {
    ...mapState('user', ['employees', 'edit_data'])
  },
  methods: {
    ...mapActions('user', ['getDataBeforCreate']),
    async fetchData() {
      this.loading = true
      await this.getDataBeforCreate()
      this.loading = false
    },
    onUpdate() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('user/update', {
          id: this.model.user_id,
          ...this.model
        })
        .then(response => {
          this.$toasted.success(response.message)
          if (this.model.loginname == this.$store.state.authUser.user_name) {
            this.logout()
          }
          // this.clearInput()
          // this.$router.push({ name: 'user'})
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    async logout() {
      await this.$store.dispatch('logout')
      this.$router.push({ name: 'login' })
    },
    setEditData() {
      console.log(this.edit_data.is_allow_back_day);
      this.$store.commit('user/SET_WAREHOUSE_LIST', [])
      if (!_.isEmpty(this.edit_data)) {
        this.edit_data.branches.map(branch => {
          if (branch.pivot.is_default == 1) {
            this.$store.dispatch('user/getWarehouse', {
              branch_id: [branch.branch_id]
            })
          }
        })

        this.model.user_id = this.edit_data.user_id
        this.model.loginname = this.edit_data.loginname
        this.model.password = '012345678' // this password value no update
        this.model.password_confirmation = '012345678'
        this.model.staff_id = this.edit_data.staff_id
        this.model.cashier_location_id = this.edit_data.cashier_location_id
        this.model.activated_type_id = this.edit_data.activated_type_id
        this.model.disable = this.edit_data.disable
        this.model.roles = this.edit_data.roles.map(el => el.id)
        this.model.branches = transform(
          this.edit_data.branches,
          function (result, branch) {
            result[branch.branch_id] = {
              is_default: Boolean(parseInt(branch.pivot.is_default))
            }
          },
          {}
        )
        this.model.sub_programs = this.edit_data.sub_programs.map(
          el => el.acps_id
        )
        this.model.permissions = this.edit_data.permissions.map(el => el.id)
        this.model.is_allow_back_day = this.edit_data.is_allow_back_day == 1
      }
    },
    clearInput() {
      this.model.loginname = null
      this.model.password = null
      this.model.password_confirmation = null
      this.model.staff_id = null
      this.model.cashier_location_id = null
      this.model.activated_type_id = 6
      this.model.disable = false
      this.model.roles = []
      this.model.branches = []
      this.model.sub_programs = []
      this.model.permissions = []
      this.model.is_allow_back_day = false
    }
  }
}
</script>
